<!-- DEPRECATED -->
<script>
	import { theme } from "$lib/utilities/theme";

	import { handleNav } from "$lib/utilities/handleNav";
	import { translate } from "$lib/utilities/translate";
	import { getLangHref } from "$lib/utilities/getLangHref";
	import { getLocation } from "$lib/utilities/getLocation";

	import FooterReviews from "$lib/sections/FooterReviews.svelte";
	import Banner from "$lib/sections/Banner.svelte";
	import MarkedContent from "$lib/components/MarkedContent.svelte";
	import LocationDetails from "$lib/sections/LocationDetails.svelte";
	import Features from "$lib/sections/Features.svelte";

	export let data;
	export let preview = false;
	export let lang;
	export let area;

	$: mainLocation = getLocation(data);

	$: locations = Object.entries(data?.content?.locations || {})
		.filter(([k, v]) => !!v.footerOrder?.value)
		.sort((a, b) =>
			a?.at(1)?.footerOrder?.value < b?.at(1)?.footerOrder?.value
				? -1
				: 1,
		)
		.map(([k, v]) => getLocation(data, k));

	$: copyrightBy =
		mainLocation?.[`displayName`]?.value ||
		mainLocation?.[`response-displayName.text`]?.value ||
		"";

	$: copyrightTag = translate(
		data?.content?.["settings"]?.["Footer"]?.copyrightTag,
		lang,
	);

	$: mapEmbedSrc = mainLocation?.mapSrc?.value;

	$: rating =
		mainLocation?.rating?.value || mainLocation?.["response-rating"]?.value;
	$: userRatingCount =
		mainLocation?.userRatingCount?.value ||
		mainLocation?.["response-userRatingCount"]?.value;

	$: reviewStatTitle = translate(
		data?.content?.settings?.["App Settings"]?.labels?.value?.statTitle,
		lang,
	);
	$: reviewRatingCountLabel = translate(
		data?.content?.settings?.["App Settings"]?.labels?.value
			?.ratingCountLabel,
		lang,
	);
	$: reviewAction = translate(
		data?.content?.settings?.["App Settings"]?.labels?.value?.reviewAction,
		lang,
	);
	$: reviewLink =
		mainLocation?.["response-googleMapsLinks.writeAReviewUri"]?.value ||
		mainLocation?.writeAReviewUri?.value;

	$: privacyPolicyLabel = translate(
		data?.content?.settings?.["Footer"]?.privacyPolicy?.value?.label,
		lang,
	);
	$: privacyPolicyHref = getLangHref(
		data?.content?.settings?.["Footer"]?.privacyPolicy?.value?.href?.value,
		lang,
		area,
	);

	$: termsOfServiceLabel = translate(
		data?.content?.settings?.["Footer"]?.termsOfService?.value?.label,
		lang,
	);
	$: termsOfServiceHref = getLangHref(
		data?.content?.settings?.["Footer"]?.termsOfService?.value?.href?.value,
		lang,
		area,
	);
	$: disclaimers = translate(
		data?.content?.settings?.["Footer"]?.disclaimers,
		lang,
		area,
		data,
	);
	$: footerClass =
		data?.content?.["settings"]?.["Footer"]?.classes?.value?.footerClass
			?.value || "bg-base-300 relative";
	$: servicesContentClass =
		data?.content?.["settings"]?.["Footer"]?.classes?.value
			?.servicesContentClass?.value ?? "mb-6";

	$: buildVersion =
		data?.content?.settings?.["App Settings"]?.buildVersion?.value;

	$: showGoogleReviews =
		data?.content?.settings?.Footer?.showGoogleReviews?.value === "false"
			? false
			: true;

	$: footerTheme = data?.content?.settings?.["Footer"]?.footerTheme?.value;
</script>

<footer
	data-theme={footerTheme || $theme}
	class={footerClass}
	id="main-app-footer"
>
	<div class="max-w-[1440px] mx-auto p-2 md:p-4 mt-12">
		<div class="">
			<div class="lg:flex lg:justify-between">
				<div>
					<div class="py-2 md:py-4 flex">
						<Banner
							{data}
							{preview}
							theme={footerTheme || $theme}
						/>
					</div>

					<div class="flex justify-between">
						<div class="my-8">
							{#if locations.length === 0}
								<LocationDetails
									locationKey={mainLocation.locationKey}
									{data}
									{lang}
									{servicesContentClass}
								/>
							{/if}

							<Features
								{data}
								col="settings"
								settingId="Features Social Media Component"
								{preview}
								{lang}
								{area}
							/>

							<!-- Reviews Section -->
							{#if showGoogleReviews}
								<div class="mt-10">
									<FooterReviews
										{reviewLink}
										{rating}
										{userRatingCount}
										statTitle={reviewStatTitle}
										ratingCountLabel={reviewRatingCountLabel}
										{reviewAction}
									/>
								</div>
							{/if}
						</div>
					</div>
				</div>

				<!-- map -->
				{#if mapEmbedSrc && locations.length === 0}
					<div class="w-full lg:w-1/2">
						<iframe
							title="Office Location"
							src={mapEmbedSrc}
							allowfullscreen=""
							loading="lazy"
							class="border-2 rounded-xl w-full h-full border-primary"
							referrerpolicy="no-referrer-when-downgrade"
						></iframe>
					</div>
				{/if}
				{#if locations.length > 0}
					{#each locations as location}
						<div class="flex align-top flex-col gap-2 sm:gap-4">
							<h2>{location.label?.value}</h2>
							<LocationDetails
								locationKey={location.locationKey}
								{data}
								{lang}
								{servicesContentClass}
							/>
							{#if location.mapSrc?.value}
								<iframe
									title="Office Location"
									src={location.mapSrc.value}
									allowfullscreen=""
									loading="lazy"
									class="border-2 rounded-xl border-primary"
									referrerpolicy="no-referrer-when-downgrade"
								></iframe>
							{/if}
						</div>
					{/each}
				{/if}
			</div>
			{#if disclaimers}
				<div class="pt-8">
					<MarkedContent markedContent={disclaimers} />
				</div>
			{/if}
		</div>

		<div class="mb-0 border-t-2 my-8 py-8">
			<div class="w-full flex justify-between items-center">
				<div class="">
					{#if privacyPolicyHref}
						<a
							class="link hover-ripple inline-block"
							href={`${privacyPolicyHref}`}
							onclick={handleNav}>{privacyPolicyLabel}</a
						>
					{/if}
					{#if privacyPolicyHref && termsOfServiceHref}
						/
					{/if}
					{#if termsOfServiceHref}
						<a
							class="link hover-ripple inline-block"
							href={termsOfServiceHref}
							onclick={handleNav}>{termsOfServiceLabel}</a
						>
					{/if}
				</div>
				<div class="text-right">
					<div>
						{`© ${(new Date().toISOString() || "").split("-")?.[0]} ${copyrightBy} ${copyrightTag}`}
					</div>

					<span
						class="absolute bottom-2 right-4 text-xs opacity-60 pointer-events-none select-none"
					>
						v{__APP_VERSION__} b{buildVersion}
					</span>
				</div>
			</div>
		</div>
	</div>
</footer>
